import { theme } from "@xola/ui-kit";
import { merge } from "lodash";
import { BaseChartOptions, fontStyle } from "./BaseChartOptions";

const { colors } = theme;

/**
 * This is the base Histogram chart. A histogram can be a line, column or a bar view. This is the master file
 * for all defaults for a histogram. This should ideally be extended by business-specific implementations like
 * revenue graph, turnover etc.
 */
export const HistogramOptions = merge({}, BaseChartOptions, {
    chart: {
        type: "line",
        marginBottom: 80,
    },
    title: {
        align: "left",
        margin: 20,
        verticalAlign: "top",
    },
    xAxis: {
        title: "", // No title by default
        type: "datetime", // This will convert time into proper dates on the axis
        dateTimeLabelFormats: { day: "%e %b", week: "%e %b" }, // Shows as '10 Jan'
        minTickInterval: 24 * 3600 * 1000,
        lineColor: colors.gray.darker,
        lineWidth: 1,
        gridLineWidth: 0,
        className: "no-translate",
    },
    yAxis: {
        title: "",
        lineColor: colors.gray.darker,
        lineWidth: 1,
        gridLineWidth: 0,
    },
    legend: {
        enabled: true,
        floating: true,
        layout: "horizontal",
        align: "left",
        verticalAlign: "bottom",
        reversed: true,
        // The style applied to each item in the legend
        itemStyle: {
            fontSize: "14px",
            color: colors.black,
            textTransform: "capitalize",
            fontFamily: fontStyle.fontFamily,
        },
        itemMarginBottom: 5,
        borderWidth: 0,
    },
    responsive: {
        rules: [
            {
                condition: { maxWidth: 630 },
                chartOptions: {
                    yAxis: {
                        labels: { align: "left", x: 0, y: -2 },
                        title: { text: "Test" },
                    },
                },
            },
        ],
    },
});
